import React, {Fragment} from "react";
import GoogleMapReact from "google-map-react";
import {Grid, Segment} from "semantic-ui-react";
import {FiClock, FiLink, FiMapPin, FiPhone, FiSend} from "react-icons/fi";
import moment from 'moment';
import {isNull} from 'lodash';
import {FormattedMessage} from "react-intl";

const days = {
    '1': <FormattedMessage id='Seg'/>,
    '2': <FormattedMessage id='Ter'/>,
    '3': <FormattedMessage id='Qua'/>,
    '4': <FormattedMessage id='Qui'/>,
    '5': <FormattedMessage id='Sex'/>,
    '6': <FormattedMessage id='Sáb'/>,
    '7': <FormattedMessage id='Dom'/>,
    '8': <FormattedMessage id='Seg-Sex'/>,
    '9': <FormattedMessage id='Seg-Sab'/>,
    '10': <FormattedMessage id='Diariamente'/>
};

const labelOptions = {
    '00:00-': <FormattedMessage id='Fechado'/>,
    '00:00-00:00': <FormattedMessage id='Fechado'/>,
    '00:00-23:59': <FormattedMessage id='Aberto 24H'/>
};

const formatHour = (hour) => {

    return moment(hour, 'YYYY-MM-DDTHH:mm:ss').format('HH:mm');
};

const getHour = (hour, count) => {

    const start1 = formatHour(hour.start);
    const end1 = formatHour(hour.end);
    const label1 = labelOptions[start1 + '-' + end1] || `${start1} - ${end1}`;

    let label2 = '';
    if (!isNull(hour.start2)) {

        const start2 = formatHour(hour.start2);
        const end2 = formatHour(hour.end2);

        label2 = labelOptions[start2 + '-' + end2] || `${start2} - ${end2}`;
    }

    if (count === 1 && (label1.props && label1.props.id) === 'Aberto 24H') {
        return (
            <div key={`hour-${hour.day}`} className={'displayHours'}>
                <div>
                    <FiClock/>
                </div>
                <div>
                    {label1}
                </div>
            </div>
        );
    }

    return (
        <div key={`hour-${hour.day}`} className={'displayHours'}>
            <div>
                <FiClock/>
            </div>
            <div>
                {days[hour.day]}:
            </div>
            <div>
                {label1}
                {label2 && <br/>}
                {label2}
            </div>
        </div>
    );
};

const Address = props => {

    const AnyReactComponent = ({text}) => (
        <div style={{width: 0}}>
            <img src={'/images/map-pin.svg'} title={text} alt={text} width={32}/>
        </div>
    );

    const {address, hours, name, contact} = props;

    const lat = parseFloat(address.lat);
    const lng = parseFloat(address.lng);

    const site = function (href) {
        const l = document.createElement("a");

        l.href = href;

        return l;
    };

    return (
        <Fragment>
            {
                address.lat &&
                <div className="map-details">
                    <GoogleMapReact
                        bootstrapURLKeys={{key: 'AIzaSyBEokzP4L4HhKoRtvRMv21faDsC9qpUbIU'}}
                        defaultCenter={[lat, lng]}
                        defaultZoom={15}
                        yesIWantToUseGoogleMapApiInternals
                        options={{
                            fullscreenControl: false,
                            zoomControl: false
                        }}
                        //onGoogleApiLoaded={({ map, maps }) => handleApiLoaded(map, maps)}
                    >
                        <AnyReactComponent lat={address.lat} lng={address.lng} text={name}/>
                    </GoogleMapReact>
                    <div className={'map-label'}>
                        <FiMapPin/> {address.formatted_address}
                    </div>
                </div>
            }
            {
                address.formatted_address && <Segment textAlign={'center'} style={{padding: 4}}>
                    <a
                        href={`https://maps.google.com/?q=${address.formatted_address}`}
                        target={'_blank'}
                    >
                        <FormattedMessage id="Abrir no mapa"/>
                    </a>
                </Segment>
            }

            <Segment className="contact-details" style={{paddingLeft: '1rem', paddingRight: '1rem'}}>
                <Grid stackable columns={'equal'}>
                    <Grid.Row>
                        <Grid.Column>
                            {
                                hours && hours.map((hour) => {

                                    return getHour(hour, hours.length);
                                })
                            }
                        </Grid.Column>
                        <Grid.Column>
                            {
                                contact.phone_1 && <div>
                                    <FiPhone/> <a href={`tel://${contact.phone_1}`}>{contact.phone_1}</a>
                                </div>
                            }
                            {
                                contact.phone_2 && <div>
                                    <FiPhone/> <a href={`tel://${contact.phone_2}`}>{contact.phone_2}</a>
                                </div>
                            }
                            {
                                contact.phone_3 && <div>
                                    <FiPhone/> <a href={`tel://${contact.phone_3}`}>{contact.phone_3}</a>
                                </div>
                            }
                        </Grid.Column>
                    </Grid.Row>

                    {
                        contact.email && <Grid.Row>
                            <Grid.Column>
                                <div className={'displayHours'}>
                                    <div>
                                        <FiSend/>
                                    </div>
                                    <div>
                                        <a href={`mailto://${contact.email}`}>{contact.email}</a>
                                    </div>
                                </div>
                            </Grid.Column>
                        </Grid.Row>
                    }

                    {
                        contact.site && <Grid.Row>
                            <Grid.Column>
                                <div className={'displayHours'}>
                                    <div>
                                        <FiLink/>
                                    </div>
                                    <div>
                                        <a href={`${contact.site}`} target={'_blank'}>{site(contact.site).hostname}</a>
                                    </div>
                                </div>
                            </Grid.Column>
                        </Grid.Row>
                    }
                </Grid>
            </Segment>
        </Fragment>
    );
};

export default Address;
